<template>
  <div>
      <v-parallax src="../assets/revendreth-bg.jpg">
        <v-row class="text-center">
          <v-col class="mb-4 d-flex flex-column justify-center align-center">
            <v-img
              contain
              src="../assets/RIFTBOYSlogo.png"
            ></v-img>
          </v-col>
        </v-row>
      </v-parallax>
 
    <v-container>
      <v-row dense>
        <v-col v-for="character in characters" :key="character.id">
          <v-card
            class="mx-auto"
            width="350"
            outlined
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4">
                  {{ character.race }}
                </div>
                <v-list-item-title class="headline mb-1">
                  {{ character.name }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ character.active_spec_name }} {{ character.class }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar
                tile
                size="80"
              >
                <img
                  alt="Avatar"
                  :src="character.thumbnail_url"
                >
              </v-list-item-avatar>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import RaiderIO from '@/services/api/RaiderIO.js'
  import WarcraftLogs from '@/services/api/WarcraftLogs.js'

  export default {
    name: 'Home',

    data () {
      return {
        guildLoading: true,
        charactersLoading: true,
        characters: [],
        guild: {},
      }
    },

    created() {
      
      WarcraftLogs.getGuild()
      .then(guild => {
        this.guild = guild
      })
      .catch(error => console.log(error))
      .finally(() => {
        this.guildLoading = false
        this.guild.members.data.forEach(member => {
          if(member.guildRank != 4)
            RaiderIO.getCharacter(member.name)
          .then(character => {
            character.guildRank = member.guildRank
            this.characters.push(character);
          })
          .catch(error => console.log(error))
          .finally(() => {
            this.charactersLoading = false
            this.characters.sort((firstEl, secondEl) => {
              if(firstEl.guildRank < secondEl.guildRank)
                return -1
              else if (firstEl.guildRank > secondEl.guildRank)
                return 1
              else if (firstEl.name < secondEl.name)
                return -1
              else if (firstEl.name > secondEl.name)
                return 1
              return 0
            })
          })
        })

      })


    }
  }
</script>
